/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { Typography, Grid, useMediaQuery, useTheme } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Button } from '@lc/legacy/src/Components';
import EPeriodType from '@lc/legacy/src/enum/EPeriodType';

const Availability = ({ title, data, setViewDetail }) => {
  const { t } = useTranslation(['booking', 'search']);
  const xsSize = useMediaQuery(useTheme().breakpoints.down('sm'));
  const hoursMsg = data.min_hours > 1 ? `, mínimo de ${data.min_hours}h por reserva.` : '';
  const renderDiscounts = onlyDescription => {
    if (onlyDescription) {
      return (
        <Typography variant={xsSize ? 'caption' : 'body1'} component="p">
          {t('explainDiscount')}
        </Typography>
      );
    }

    return (
      <>
        <Typography variant="body1" style={{ marginBottom: '16px' }}>
          {t('explainDiscount')}
        </Typography>
        {data.discounts
          .filter(item => item.value > 0)
          .map(item => (
            <Typography key={item.period}>
              {t('discountsByPeriod', { period: item.period, discount: item.value })}
            </Typography>
          ))}
      </>
    );
  };

  const equipment = data.expertise === 'Equipamento' || data.clinic === 'Equipamento';

  return (
    <Grid container spacing={0}>
      <Grid item xs={12}>
        {data.period_type !== EPeriodType.HOURS && data.discounts.reduce((acc, discount) => acc + discount.value, 0) > 0 ?
          <>
            <Typography variant={xsSize ? 'body2' : 'body1'} color="textPrimary">
              <b>{title}</b>
            </Typography>
            {data.discounts.some(item => item.value > 0) && (
              <>
                {renderDiscounts(xsSize)}
                {xsSize && (
                  <Button
                    style={{ padding: 0, minWidth: 'auto', maxHeight: '30px' }}
                    size="xs"
                    onClick={() => {
                      setViewDetail({
                        title: t('specialDiscounts'),
                        content: <>{renderDiscounts(false)}</>,
                      });
                    }}
                  >
                    <Typography variant="caption" color="secondary">
                      <b>{t('checkIt')}</b>
                    </Typography>
                  </Button>
                )}
              </>
            )}

            <Grid item xs={12}>
              <hr style={{ border: '0', height: '1px', backgroundColor: '#a6a6a673' }} />
            </Grid>
          </>
          : null}

        <Grid item xs={12}>
          <Typography
            variant={xsSize ? 'body2' : 'body1'}
            color="textPrimary"
            style={{ marginTop: '20px' }}
          >
            <b>
              Clique nas datas disponíveis no calendário e selecione os períodos que deseja alugar
            </b>
          </Typography>

          <Typography
            variant={xsSize ? 'body2' : 'body1'}
            color="textPrimary"
            style={{ marginTop: '20px' }}
          >
            {data.period_type !== EPeriodType.HOURS ? t('periodsAvailable', { hoster: data.firstName }) : t('hoursAvailable', { hoster: data.firstName, equipment: !equipment ? 'espaço' : 'equipamento' })}:
          </Typography>
          {
            data.period_type !== EPeriodType.HOURS ? data.availability[0].calendar.periods.map((item, idx) => {
              const time = item.split(':')[0];
              return (
                <Typography variant={xsSize ? 'body2' : 'body1'} component="span" key={item}>
                  {t('periodsAvailableTime', { start: time, end: Number(time) + 4 })}

                  {idx < data.availability[0].calendar.periods.length - 1 && ' | '}
                </Typography>
              );
            }) : `${data.initial_period.split(':')[0]}h até ${data.final_period.split(':')[0]}h${hoursMsg}`

          }


        </Grid>
      </Grid>
    </Grid>
  );
};
const styles = () => ({});

Availability.propTypes = {
  data: PropTypes.object.isRequired,
  setViewDetail: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};
export default withStyles(styles)(Availability);
